////////////////////

import base_module from '@/vue-model-mirror/stores/base_v2.module';

var options = {
    model_name    : 'company',
    send_alert    : false,
    default_order : 'label ASC',
};

var base = new base_module( options );

const state = {
    ...base.state,
    filters : {},
};

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
};

const getters = {
    ...base.getters,
}

export default {
    namespaced : true,
    ...base,
    state,
    actions,
    mutations,
    getters,
};

